/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_REPORTS,
  GET_REPORTS_ERROR,
  GET_REPORTS_EMPTY,
  GET_REPORT_DTO,
  GET_REPORT_DTO_ERROR,
  GET_REPORT_DTO_EMPTY,
  CREATE_REPORT,
  CREATE_REPORT_ERROR,
  CREATE_REPORT_EMPTY,
  EDIT_REPORT,
  EDIT_REPORT_ERROR,
  EDIT_REPORT_EMPTY,
  DELETE_REPORT,
  DELETE_REPORT_ERROR,
  DELETE_EMPTY,
  DELETE_BANK,
  DELETE_BANK_ERROR,
  DELETE_BANK_EMPTY,
  DELETE_BUREAU,
  DELETE_BUREAU_ERROR,
  DELETE_ACCOUNT_COUNT,
  DOWNLOAD_CAM,
  DOWNLOAD_CAM_ERROR,
  DOWNLOAD_CAM_EMPTY,
  DOWNLOAD_AG_CAM,
  DOWNLOAD_AG_CAM_ERROR,
  DOWNLOAD_AG_CAM_EMPTY,
  DOWNLOAD_ALLAG_CAM,
  DOWNLOAD_ALLAG_CAM_ERROR,
  DOWNLOAD_ALLAG_CAM_EMPTY,
  DOWNLOAD_GST_CAM,
  DOWNLOAD_GST_CAM_ERROR,
  DOWNLOAD_GST_CAM_EMPTY,
  DOWNLOAD_BUREAU_CAM,
  DOWNLOAD_BUREAU_CAM_ERROR,
  DOWNLOAD_BUREAU_CAM_EMPTY,
  DOWNLOAD_CREDIT_REPORT,
  DOWNLOAD_CREDIT_REPORT_ERROR,
  GET_EXTRACT_DATA,
  GET_EXTRACT_DATA_ERROR,
  EXTRACT_DATA_EMPTY,
  LOADER,
  NEW_REPORT_STATUS_TRACKER_EMPTY,
  DELETED_ACCOUNT_STATUS_EMPTY,
  STORE_BANKLIST,
  STOP_LOADER,
  GST_EMPTY,
  GST_ERROR,
  GST_DETAIL,
  SAVE_GST_DETAIL,
  SAVE_GST_ERROR,
  SAVE_GST_EMPTY,
  VERIFY_GST_LOGIN_SUCCESS,
  VERIFY_GST_LOGIN_ERROR,
  VERIFY_GST_LOGIN_EMPTY,
  GET_EXTRACT_GST_DATA,
  GET_EXTRACT_GST_DATA_ERROR,
  EXTRACT_GST_DATA_EMPTY,
  GET_ADDITIONAL_REPORT,
  REPORT_ACCOUNTS_REANALYSIS,
  REPORT_ACCOUNTS_REANALYSIS_ERROR,
  ACC_EXPAND_PERSIST,
  STORE_SELECTED_REPORTS,
  REPORT_LIST_DOWNLOAD,
  REPORT_LIST_DOWNLOAD_ERROR,
  REPORT_LIST_DOWNLOAD_EMPTY,
  USER_OPTIONS,
  USER_OPTIONS_ERROR,
  DOWNLOAD_AGG_GST_CAM,
  DOWNLOAD_AGG_GST_CAM_ERROR,
  DOWNLOAD_AGG_GST_CAM_EMPTY,
  DOWNLOAD_AGG_BUREAU_CAM,
  DOWNLOAD_AGG_BUREAU_CAM_ERROR,
  GET_EXTRACT_CIC_DATA,
  GET_EXTRACT_CIC_DATA_ERROR,
  EXTRACT_CIC_DATA_EMPTY,
  GET_CREDIT_BUREAU_LIST,
  FREE_TRIAL_DATA,
  PPU_PAYMENT_DATA,
  PPU_PAYMENT_DATA_ERROR,
  REDIRECT_TO_CREATE_REPORT,
  REDIRECT_TO_CREATE_REPORT_FALSE,
  REPORT_LIST_ELEMENT,
  REPORT_LIST_ELEMENT_INCREMENT,
  SAVE_GST_DETAIL_EMPTY,
  GST_DETAIL_EMPTY
} from 'src/actions/reportActions';

const initialState = {
  reports: null,
  reportsError: null,
  reportDto: null,
  reportDtoError: null,
  createSuccess: null,
  createError: null,
  editSuccess: null,
  editError: null,
  deleteReportSuccess: null,
  deleteReportError: null,
  deleteBankSuccess: [],
  deleteBankError: null,
  deleteAccountCount: null,
  downloadCamSuccess: null,
  downloadCamError: null,
  downloadAgCamSuccess: null,
  downloadAgCamError: null,
  downloadAllAgCamSuccess: null,
  downloadAllAgCamError: null,
  downloadGstCamSuccess: null,
  downloadGstCamError: null,
  downloadAggGstCamSuccess: null,
  downloadAggGstCamError: null,
  downloadBureauCamSuccess: null,
  downloadBureauCamError: null,
  downloadAggBureauCamSuccess: null,
  downloadAggBureauCamError: null,
  downloadCreditReport: null,
  downloadCreditReportError: null,
  extractData: null,
  statusCode: [],
  extractDataError: null,
  isLoading: false,
  loadingText: null,
  newReportStatusTracker: null,
  deletedAccoutStatusTracker: null,
  bankListRedux: [],
  gstDetail: null,
  gstDetailError: null,
  saveGstSuccess: [],
  saveGstError: [],
  gstVerifySuccess: null,
  gstVerifyError: null,
  extractGstData: null,
  extractGstDataError: null,
  initialObjectRedux: null,
  initialObjectRedux: {},
  filesRedux: [],
  deletedStatementsRedux: {},
  deletedAccountListRedux: [],
  deletedLimitIdsRedux: [],
  reportDetailsRedux: {},
  reportAdditionalDetails: null,
  reportAccountsRenalysis: null,
  accountExpandPersist: {},
  storedSelectedReports: [],
  downloadReportListSuccess: null,
  downloadReportListError: null,
  userOptions: [],
  userOptionsError: null,
  downloadAggGstCamSuccess: null,
  downloadAggGstCamError: null,
  creditBureauList: [],
  freeTrialData: null,
  ppuPaymentData: null,
  isRedirectToCreateReport: false,
  totalReportsListed: 1
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER: {
      return produce(state, draft => {
        draft.isLoading = true;
        draft.loadingText = action.payload || null;
      });
    }
    case GET_REPORTS: {
      const reports = action.payload;
      return produce(state, draft => {
        draft.reports = reports;
        draft.reportsError = null;
        draft.isLoading = false;
      });
    }
    case GET_REPORTS_ERROR: {
      const reportsError = action.payload;
      return produce(state, draft => {
        draft.reportsError = reportsError;
        draft.isLoading = false;
      });
    }
    case GET_REPORTS_EMPTY: {
      return produce(state, draft => {
        draft.reportsError = null;
        draft.reports = null;
      });
    }

    case GET_REPORT_DTO: {
      const reportDto = action.payload;
      return produce(state, draft => {
        draft.reportDto = reportDto;
        draft.isLoading = false;
      });
    }
    case GET_REPORT_DTO_ERROR: {
      const reportDtoError = action.payload;
      return produce(state, draft => {
        draft.reportDtoError = reportDtoError;
        draft.isLoading = false;
      });
    }
    case GET_REPORT_DTO_EMPTY: {
      return produce(state, draft => {
        draft.reportDto = null;
        draft.reportDtoError = null;
      });
    }

    case CREATE_REPORT: {
      const createSuccess = action.payload;
      return produce(state, draft => {
        draft.createSuccess = createSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
        draft.newReportStatusTracker = true;
      });
    }
    case CREATE_REPORT_ERROR: {
      const createError = action.payload;
      return produce(state, draft => {
        draft.createError = createError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case CREATE_REPORT_EMPTY: {
      return produce(state, draft => {
        draft.createError = null;
        draft.createSuccess = null;
        draft.loadingText = null;
      });
    }
    case EDIT_REPORT: {
      const editSuccess = action.payload;
      return produce(state, draft => {
        draft.editSuccess = editSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case EDIT_REPORT_ERROR: {
      const editError = action.payload;
      return produce(state, draft => {
        draft.editError = editError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case EDIT_REPORT_EMPTY: {
      return produce(state, draft => {
        draft.editError = null;
        draft.editSuccess = null;
        draft.addBankError = null;
        draft.addBankSuccess = null;
        draft.deleteBankError = null;
        draft.deleteBankSuccess = [];
      });
    }
    case DELETE_REPORT: {
      const deleteReportSuccess = action.payload;
      return produce(state, draft => {
        draft.deleteReportSuccess = deleteReportSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DELETE_REPORT_ERROR: {
      const deleteReportError = action.payload;
      return produce(state, draft => {
        draft.deleteReportError = deleteReportError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DELETE_EMPTY: {
      return produce(state, draft => {
        draft.deleteReportError = null;
        draft.deleteReportSuccess = null;
        draft.loadingText = null;
      });
    }
    case DELETE_BANK: {
      const deleteBankRes = action.payload;
      return produce(state, draft => {
        draft.deleteBankSuccess = state.deleteBankSuccess.concat([
          deleteBankRes
        ]);
        draft.isLoading = false;
        draft.deletedAccoutStatusTracker = true;
      });
    }
    case DELETE_BANK_ERROR: {
      const deleteBankError = action.payload;
      return produce(state, draft => {
        draft.deleteBankError = deleteBankError;
        draft.isLoading = false;
      });
    }
    case DELETE_BANK_EMPTY: {
      return produce(state, draft => {
        draft.deleteBankError = null;
        draft.deleteBankSuccess = null;
      });
    }
    case DELETE_BUREAU: {
      const deleteBureauRes = action.payload;
      return produce(state, draft => {
        draft.deleteBankSuccess = state.deleteBureauSuccess.concat([
          deleteBureauRes
        ]);
        draft.isLoading = false;
        draft.deletedAccoutStatusTracker = true;
      });
    }
    case DELETE_BUREAU_ERROR: {
      const deleteBureauError = action.payload;
      return produce(state, draft => {
        draft.deleteBureauError = deleteBureauError;
        draft.isLoading = false;
      });
    }
    case DELETE_ACCOUNT_COUNT: {
      return produce(state, draft => {
        draft.deleteAccountCount = action.payload;
      });
    }

    case DOWNLOAD_CAM: {
      const downloadCamSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadCamSuccess = downloadCamSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_CAM_ERROR: {
      const downloadCamError = action.payload;
      return produce(state, draft => {
        draft.downloadCamError = downloadCamError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_CAM_EMPTY: {
      return produce(state, draft => {
        draft.downloadCamError = null;
        draft.downloadCamSuccess = null;
      });
    }

    case DOWNLOAD_AG_CAM: {
      const downloadAgCamSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadAgCamSuccess = downloadAgCamSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_AG_CAM_ERROR: {
      const downloadAgCamError = action.payload;
      return produce(state, draft => {
        draft.downloadAgCamError = downloadAgCamError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_AG_CAM_EMPTY: {
      return produce(state, draft => {
        draft.downloadAgCamError = null;
        draft.downloadAgCamSuccess = null;
        draft.downloadAggBureauCamSuccess = null;
      });
    }
    case DOWNLOAD_AGG_GST_CAM: {
      const downloadAggGstCamSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadAggGstCamSuccess = downloadAggGstCamSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_AGG_GST_CAM_ERROR: {
      const downloadAggGstCamError = action.payload;
      return produce(state, draft => {
        draft.downloadAggGstCamError = downloadAggGstCamError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_AGG_GST_CAM_EMPTY: {
      return produce(state, draft => {
        draft.downloadAgCamError = null;
        draft.downloadAgCamSuccess = null;
      });
    }
    case DOWNLOAD_ALLAG_CAM: {
      const downloadAllAgCamSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadAllAgCamSuccess = downloadAllAgCamSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_ALLAG_CAM_ERROR: {
      const downloadAllCamError = action.payload;
      return produce(state, draft => {
        draft.downloadAllCamError = downloadAllCamError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_ALLAG_CAM_EMPTY: {
      return produce(state, draft => {
        draft.downloadAllCamError = null;
        draft.downloadAllAgCamSuccess = null;
      });
    }

    case DOWNLOAD_GST_CAM: {
      const downloadGstCamSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadGstCamSuccess = downloadGstCamSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_GST_CAM_ERROR: {
      const downloadGstCamError = action.payload;
      return produce(state, draft => {
        draft.downloadGstCamError = downloadGstCamError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_GST_CAM_EMPTY: {
      return produce(state, draft => {
        draft.downloadGstCamError = null;
        draft.downloadGstCamSuccess = null;
      });
    }

    case DOWNLOAD_BUREAU_CAM: {
      const downloadBureauCamSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadBureauCamSuccess = downloadBureauCamSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_BUREAU_CAM_ERROR: {
      const downloadBureauCamError = action.payload;
      return produce(state, draft => {
        draft.downloadBureauCamError = downloadBureauCamError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_BUREAU_CAM_EMPTY: {
      return produce(state, draft => {
        draft.downloadBureauCamError = null;
        draft.downloadBureauCamSuccess = null;
      });
    }

    case GET_EXTRACT_DATA: {
      const extractData = action.payload;
      return produce(state, draft => {
        draft.extractData = extractData;
        draft.statusCode = extractData.map(data => data.statusCode);
      });
    }
    case GET_EXTRACT_DATA_ERROR: {
      const extractDataError = action.payload;
      return produce(state, draft => {
        draft.extractDataError = extractDataError;
        draft.statusCode = [];
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case EXTRACT_DATA_EMPTY: {
      return produce(state, draft => {
        draft.extractData = null;
        draft.statusCode = [];
        draft.extractDataError = null;
        draft.loadingText = null;
      });
    }

    case GET_CREDIT_BUREAU_LIST: {
      return produce(state, draft => {
        draft.creditBureauList = action.payload;
      });
    }

    case NEW_REPORT_STATUS_TRACKER_EMPTY: {
      return produce(state, draft => {
        draft.newReportStatusTracker = null;
        draft.deletedAccoutStatusTracker = null;
      });
    }

    case STORE_BANKLIST: {
      return produce(state, draft => {
        draft.bankListRedux = action.payload;
        draft.initialObjectRedux = action.payload1;
        draft.filesRedux = action.payload2;
        draft.deletedStatementsRedux = action.payload3;
        draft.deletedAccountListRedux = action.payload4;
        draft.deletedLimitIdsRedux = action.payload5;
        draft.reportDetailsRedux = action.payload6;
        draft.deletedGstFilesRedux = action.payload7;
        draft.gstFilesRedux = action.payload8;
      });
    }

    case STOP_LOADER: {
      return produce(state, draft => {
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case GET_ADDITIONAL_REPORT: {
      return produce(state, draft => {
        draft.reportAdditionalDetails = action.payload;
      });
    }
    case REPORT_ACCOUNTS_REANALYSIS: {
      return produce(state, draft => {
        draft.reportAccountsRenalysis = action.payload;
        draft.isLoading = false;
      });
    }
    case REPORT_ACCOUNTS_REANALYSIS_ERROR: {
      return produce(state, draft => {
        draft.reportAccountsRenalysis = null;
        draft.isLoading = false;
      });
    }
    case ACC_EXPAND_PERSIST: {
      return produce(state, draft => {
        draft.accountExpandPersist = {
          ...state.accountExpandPersist,
          [action.reportIdPayload]: {
            ...state.accountExpandPersist[action.reportIdPayload],
            [action.accountIdPayload]: action.payload
          }
        };
      });
    }
    case STORE_SELECTED_REPORTS: {
      return produce(state, draft => {
        draft.storedSelectedReports = action.payload;
      });
    }

    case REPORT_LIST_DOWNLOAD: {
      const downloadReportListSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadReportListSuccess = downloadReportListSuccess;
        draft.isLoading = false;
      });
    }
    case REPORT_LIST_DOWNLOAD_ERROR: {
      const downloadReportListError = action.payload;
      return produce(state, draft => {
        draft.downloadReportListError = downloadReportListError;
        draft.isLoading = false;
      });
    }
    case REPORT_LIST_DOWNLOAD_EMPTY: {
      return produce(state, draft => {
        draft.downloadReportListError = null;
        draft.downloadReportListSuccess = null;
      });
    }

    case GST_DETAIL: {
      const gstDetail = action.payload;
      const existingGstDetail = action.payload2;
      const newArray = [...(existingGstDetail || []), gstDetail];
      return produce(state, draft => {
        draft.gstDetail = newArray;
        draft.isLoading = false;
        draft.gstDetailError = null;
      });
    }

    case GST_DETAIL_EMPTY: {
      return produce(state, draft => {
        draft.gstDetail = null;
      });
    }

    case GST_ERROR: {
      const gstDetailError = action.payload;
      return produce(state, draft => {
        draft.gstDetailError = gstDetailError;
        draft.isLoading = false;
      });
    }
    case GST_EMPTY: {
      return produce(state, draft => {
        draft.gstDetailError = null;
      });
    }

    case SAVE_GST_DETAIL: {
      const saveGstSuccess = action.payload;
      const existingSaveGstSuccess = action.payload2;
      const newArray = [...(existingSaveGstSuccess || [])];
      const index = action.payload1; // Specify the index where the new object should be added
      const idToReplace = saveGstSuccess && saveGstSuccess.gstId;
      const indexToReplace = newArray.findIndex(
        item => item?.gstId === idToReplace
      );
      if (indexToReplace !== -1) {
        // If an object with the same ID exists, replace it with the latest response
        newArray[indexToReplace] = saveGstSuccess;
      } else {
        // If the ID is not found, add the new response to the array at the specified index
        // newArray.splice(index, 0, saveGstSuccess);
        newArray[index] = saveGstSuccess;
      }

      return produce(state, draft => {
        draft.saveGstSuccess = newArray;
        draft.isLoading = false;
        draft.saveGstError = [];
      });
    }

    case SAVE_GST_DETAIL_EMPTY: {
      return produce(state, draft => {
        draft.saveGstSuccess = [];
        draft.saveGstError = [];
      });
    }

    case SAVE_GST_ERROR: {
      const saveGstError = action.payload;
      const index = action.payload1;
      const existingSaveGstError = action.payload2;

      // Create a copy of the existing errors array
      const newArray = [...(existingSaveGstError || [])];

      // Check if an error exists at the specified index
      if (newArray[index]) {
        // Replace the existing error with the new error
        newArray[index] = saveGstError;
      } else {
        // If no error exists at the specified index, add the new error
        newArray[index] = saveGstError;
      }

      return produce(state, draft => {
        draft.saveGstError = newArray;
        draft.isLoading = false;
      });
    }

    case SAVE_GST_EMPTY: {
      return produce(state, draft => {
        // to be changed commented to test saveGstrError flow.
        // draft.saveGstError = null;
      });
    }

    case VERIFY_GST_LOGIN_SUCCESS: {
      const gstVerifySuccess = action.payload;
      return produce(state, draft => {
        draft.gstVerifySuccess = gstVerifySuccess;
        draft.isLoading = false;
        draft.gstVerifyError = null;
      });
    }
    case VERIFY_GST_LOGIN_ERROR: {
      const gstVerifyError = action.payload;
      return produce(state, draft => {
        draft.gstVerifyError = gstVerifyError;
        draft.gstVerifySuccess = null;
        draft.isLoading = false;
      });
    }
    case VERIFY_GST_LOGIN_EMPTY: {
      return produce(state, draft => {
        draft.gstVerifyError = null;
        draft.gstVerifySuccess = null;
        draft.isLoading = false;
      });
    }

    case GET_EXTRACT_GST_DATA: {
      const extractGstData = action.payload;
      return produce(state, draft => {
        draft.extractGstData = extractGstData;
      });
    }
    case GET_EXTRACT_GST_DATA_ERROR: {
      const extractGstDataError = action.payload;
      return produce(state, draft => {
        draft.extractGstDataError = extractGstDataError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case EXTRACT_GST_DATA_EMPTY: {
      return produce(state, draft => {
        draft.extractGstData = null;
        draft.extractGstDataError = null;
        draft.loadingText = null;
      });
    }
    case GET_EXTRACT_CIC_DATA: {
      const extractCicData = action.payload;
      return produce(state, draft => {
        draft.extractCicData = extractCicData;
      });
    }
    case GET_EXTRACT_CIC_DATA_ERROR: {
      const extractCicDataError = action.payload;
      return produce(state, draft => {
        draft.extractCicDataError = extractCicDataError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case EXTRACT_CIC_DATA_EMPTY: {
      return produce(state, draft => {
        draft.extractCicData = null;
        draft.extractCicDataError = null;
        draft.loadingText = null;
      });
    }
    case USER_OPTIONS: {
      const userOptions = action.payload;
      return produce(state, draft => {
        draft.userOptions = userOptions;
        draft.isLoading = false;
      });
    }
    case USER_OPTIONS_ERROR: {
      const userOptionsError = action.payload;
      return produce(state, draft => {
        draft.userOptionsError = userOptionsError;
        draft.isLoading = false;
      });
    }

    case DOWNLOAD_AGG_GST_CAM: {
      const downloadAggGstCamSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadAggGstCamSuccess = downloadAggGstCamSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_AGG_GST_CAM_ERROR: {
      const downloadAggGstCamError = action.payload;
      return produce(state, draft => {
        draft.downloadAggGstCamError = downloadAggGstCamError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_AGG_GST_CAM_EMPTY: {
      return produce(state, draft => {
        draft.downloadAgCamError = null;
        draft.downloadAgCamSuccess = null;
      });
    }

    case DOWNLOAD_AGG_BUREAU_CAM: {
      const downloadAggBureauCamSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadAggBureauCamSuccess = downloadAggBureauCamSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_AGG_BUREAU_CAM_ERROR: {
      const downloadAggBureauCamError = action.payload;
      return produce(state, draft => {
        draft.downloadAggBureauCamError = downloadAggBureauCamError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_CREDIT_REPORT: {
      const downloadCreditReportSuccess = action.payload;
      return produce(state, draft => {
        draft.downloadCreditReportSuccess = downloadCreditReportSuccess;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case DOWNLOAD_CREDIT_REPORT_ERROR: {
      const downloadCreditReportError = action.payload;
      return produce(state, draft => {
        draft.downloadCreditReportError = downloadCreditReportError;
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }
    case FREE_TRIAL_DATA: {
      const freeTrialData = action.payload;
      return produce(state, draft => {
        draft.freeTrialData = freeTrialData;
        draft.isLoading = false;
      });
    }
    case PPU_PAYMENT_DATA: {
      const ppuPaymentData = action.payload;
      return produce(state, draft => {
        draft.ppuPaymentData = ppuPaymentData;
        draft.isLoading = false;
      });
    }

    case PPU_PAYMENT_DATA_ERROR: {
      return produce(state, draft => {
        draft.isLoading = false;
        draft.loadingText = null;
      });
    }

    case REDIRECT_TO_CREATE_REPORT: {
      return produce(state, draft => {
        draft.isRedirectToCreateReport = true;
        draft.totalReportsListed =
          typeof action.payload === 'number'
            ? action.payload + 1
            : parseInt(action.payload) + 1;
      });
    }

    case REDIRECT_TO_CREATE_REPORT_FALSE: {
      return produce(state, draft => {
        draft.isRedirectToCreateReport = false;
      });
    }

    case REPORT_LIST_ELEMENT: {
      return produce(state, draft => {
        draft.totalReportsListed =
          typeof action.payload === 'number'
            ? action.payload + 1
            : parseInt(action.payload) + 1;
      });
    }

    case REPORT_LIST_ELEMENT_INCREMENT: {
      return produce(state, draft => {
        draft.totalReportsListed = state.totalReportsListed + 1;
      });
    }

    default: {
      return state;
    }
  }
};

export default reportReducer;
